import React, { useState, useEffect } from 'react'
import MobileTooltip from './MobileTooltip'
import DesktopTooltip from './DesktopTooltip'

const index = (props) => {
  return (
    <>
      <div className="inline lg:hidden">
        <MobileTooltip {...props} />
      </div>
      <div className="hidden lg:inline">
        <DesktopTooltip {...props} />
      </div>
    </>
  )
}

export default index
